var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"menu-button",class:{ active: _vm.menuOpen },on:{"click":_vm.emitToggleMenu}},[_c('div',{staticClass:"line menu-top"}),_c('div',{staticClass:"line menu-middle"}),_c('div',{staticClass:"line menu-bottom"})])}
var staticRenderFns = []

export { render, staticRenderFns }